module.exports = __webpack_public_path__ + "static/img/zwsj.74a48d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zwsj.jpg
// module id = XVYW
// module chunks = 1